var React = require('react');

var Timeline = React.createClass({
    render: function(){
        return (
            <div className="soccerTimeline mobile sub-module" data-behavior="soccer_timeline">

                <div className="teamWrap away">
                    <a href="#">
                        <div className="logo">
                           <img alt="" src="http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/360.png&amp;w=22&amp;site=espnfc" width="22" />
                        </div>
                        <div className="teamName">MUN</div>
                    </a>
                </div>

                <div className="gameProgressWrap">
                   <div className="gameProgress">

                        <ul className="timeline">
                            <li><span className="gameTimeIndicator solid">KO</span></li>

                            <li className="items-1">
                                <div className="number">6</div>
                                <div className="mobile iconNotification home">
                                    <div className="iconWrap active">
                                        <div className="tooltipWrap">
                                            <div className="tooltip">
                                                <span className="playerTooltip left">Player Tooltip</span>
                                            </div>
                                        </div>
                                        <span className="icon-font-before icon-soccer-ball-before icon-soccerball"></span>
                                    </div>
                                </div>
                            </li>

                            <li className="items-2">
                                <div className="number">22</div>
                                <div className="mobile iconNotification away group">
                                    <div className="iconWrap active">
                                        <div className="tooltipWrap">
                                            <div className="tooltip">
                                                <div className="groupSingleTooltipWrap">
                                                    <span className="playerTooltip right">Player Tooltip</span>
                                                    <span className="playerTooltip right">Player Tooltip</span>
                                                </div>
                                            </div>
                                        </div>
                                        <span className="icon-font-before icon-soccer-card02-solid-before icon-yellowcard"></span>
                                        <span className="icon-font-before icon-soccer-card02-solid-before icon-redcard"></span>
                                    </div>
                                </div>
                                <div className="mobile iconNotification home group">
                                    <div className="iconWrap active">
                                        <div className="tooltipWrap">
                                            <div className="tooltip">
                                                <div className="groupSingleTooltipWrap">
                                                    <span className="playerTooltip left">Player Tooltip</span>
                                                    <span className="playerTooltip left">Player Tooltip</span>
                                                </div>
                                            </div>
                                        </div>
                                        <span className="icon-font-before icon-soccer-card02-solid-before icon-yellowcard"></span>
                                        <span className="icon-font-before icon-soccer-card02-solid-before icon-redcard"></span>
                                    </div>
                                </div>
                            </li>

                            <li><span className="gameTimeIndicator halfTime solid">HT</span></li>

                            <li className="items-1">
                                <div className="number">58</div>
                                <div className="mobile iconNotification away">
                                    <div className="iconWrap active">
                                        <div className="tooltipWrap">
                                            <div className="tooltip">
                                                <span className="playerTooltip right">Player Tooltip</span>
                                            </div>
                                        </div>
                                        <span className="icon-font-before icon-soccer-ball-before icon-soccerball"></span>
                                    </div>
                                </div>
                            </li>

                            <li style={{top:'100px'}}><span className="gameTimeIndicator halfTime stroke">FT</span></li>
                        </ul>
                    </div>
                </div>

                <div className="teamWrap home">
                    <a href="#">
                        <div className="teamName">MCY</div>
                        <div className="logo">
                            <img alt="" src="http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/382.png&amp;w=22&amp;site=espnfc" width="22" />
                        </div>
                    </a>
                </div>
            </div>
        );
    }
})

module.exports = Timeline;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/VerticalTimeline.jsx
 **/